module.exports = __webpack_public_path__ + "f683a1a3cf4ce0c6450c8243099415f4.png";